<ng-template #modalContent let-c="close" let-d="dismiss">
    <div class="modal-header bg-primary text-white">{{ 'notificationDetails' | translate }}</div>
    <div class="notification-modal modal-body">
        <ul class="list-group">
            <li class="list-group-item">{{ 'website' | translate }}: {{ selectedNotification.website }}</li>
            <li class="list-group-item">{{ 'page' }}: {{ selectedNotification.page }}</li>
            <li class="list-group-item" *ngFor="let messageLine of selectedNotificationMessageArray">{{ messageLine }}</li>
            <li class="list-group-item">{{ 'status' }}: {{ selectedNotification.status }}</li>
        </ul>
    </div>
    <div class="modal-footer">
        <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
            <button type="button" class="btn btn-sm btn-primary" id="dropdownManual" ngbDropdownToggle>Choose action</button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button type="button" class="dropdown-item capitalize" (click)="selectedNotifationAction = NotificationActionEnum.Email">{{ 'sendEmail' | translate}}</button>
                <button type="button" class="dropdown-item capitalize" (click)="selectedNotifationAction = NotificationActionEnum.FogBugz">{{ 'crateFogBugztask' | translate}}</button>
            </div>
        </div>
        <div [ngSwitch]="selectedNotifationAction" class="notification-action-forms">
            <div *ngSwitchCase="NotificationActionEnum.Email">
                <h6 class="text-center mt-3">{{ 'sendNotificationAsEmail' | translate }}</h6>
                <form novalidate [formGroup]="emailForm" (submit)="onEmailFormSubmit($event)">
                    <label>{{ 'emailAddress' | translate }}</label>
                    <input name="email" [formControl]="emailForm.get('email')" class="form-control"/>
                    <div [val-messages]="emailForm.get('email')">
                        <span val-message="email">{{ 'invalidEmailAddress' | translate }}</span>
                    </div>
                    <div class="mt-2">
                        <button [ladda]="isLoading" type="submit" class="btn btn-sm btn-primary pull-right">Send</button>
                    </div>
                </form>
            </div>
            <div *ngSwitchCase="NotificationActionEnum.FogBugz">
                 <form novalidate [formGroup]="fogbugzForm" (submit)="onFogbugzFormSubmit($event)">
                    Not implemented
                </form>
            </div>
            <div><p class="error-message text-center">{{ responseMessage }}</p></div>
        </div>
    </div>
</ng-template>

<div class="row">
    <div class="col-md-8">
        <input #search class="form-control" type="text" placeholder="Search..." (input)="onSearch(search.value)">
    </div>
</div>
<br>
<ng2-smart-table [settings]="settings" [source]="source" (userRowSelect)="onUserRowSelect($event)"></ng2-smart-table>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/notifications/notifications-table/notifications-table.component.html